import React from "react";
import { MdLatex } from "utils/md-latex/md-latex";
import { TextContentWrapper } from "./session-card.styles";

interface PracticeTextContentProps {
  text: string;
}

export const PracticeTextContent: React.FC<PracticeTextContentProps> = ({
  text
}) => {
  return (
    <TextContentWrapper>
      <MdLatex text={text} />
    </TextContentWrapper>
  );
};
